import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ElectricBoltRoundedIcon from "@mui/icons-material/ElectricBoltRounded";
import ConstructionSharpIcon from "@mui/icons-material/ConstructionSharp";
import FeatureRequest from "components/FeatureRequest/FeatureRequest";
import ReportAProblem from "components/ReportAProblem/ReportAProblem";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import classes from "./HeaderMenu.module.css";
import AccessRequest from "components/AccessRequest/AccessRequest";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import InsightsIcon from "@mui/icons-material/Insights";
const HeaderMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [modalState, setModalState] = React.useState({
    accessRequest: false,
    featureRequest: false,
    reportError: false,
  });

  const navigate = useNavigate();
  const { hasAnyPermission } = useAuth();
  const canViewLogInsights = hasAnyPermission(["LD_Group_Admin", "OG_Group"]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseModal = () => {
    setModalState({
      featureRequest: false,
      reportError: false,
    });
  };

  return (
    <>
      {" "}
      <MoreVertIcon
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        className={classes.menuIcon}
        onClick={handleClick}
      ></MoreVertIcon>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{
          horizontal: "right",
          vertical: "top",
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        className={classes.menu}
      >
        <MenuItem
          onClick={() => {
            setModalState({
              ...modalState,
              accessRequest: true,
            });
            handleClose();
          }}
        >
          <div className={classes.icon}>
            <SupportAgentIcon />
            Access Request
          </div>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setModalState({
              ...modalState,
              featureRequest: true,
            });
            handleClose();
          }}
        >
          <div className={classes.icon}>
            <ElectricBoltRoundedIcon />
            Feature Request
          </div>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setModalState({
              ...modalState,
              reportError: true,
            });
            handleClose();
          }}
        >
          <div className={classes.icon}>
            <ConstructionSharpIcon />
            Report a problem
          </div>
        </MenuItem>
        {canViewLogInsights && (
          <MenuItem
            onClick={() => {
              navigate("/log-insights");
              handleClose();
            }}
          >
            <div className={classes.icon}>
              <InsightsIcon />
              Log Insights
            </div>
          </MenuItem>
        )}
      </Menu>
      <AccessRequest
        state={modalState.accessRequest}
        handleClose={handleCloseModal}
      />
      <FeatureRequest
        state={modalState.featureRequest}
        handleClose={handleCloseModal}
      />
      <ReportAProblem
        state={modalState.reportError}
        handleClose={handleCloseModal}
      />
    </>
  );
};

export default HeaderMenu;
